import { Outlet, Navigate } from 'react-router';
import { useAuth } from "@/hooks/useAuth";
import { AppCore } from './AppCore';
import { Loader } from '../Loader/Loader';

export const AuthLayout = () => {
  const { isSignedIn, inProgress } = useAuth();

  if (inProgress) {
    return <Loader />;
  }

  if (!isSignedIn) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AppCore>
      <Outlet />
    </AppCore>
  );
};
